module.exports = __webpack_public_path__ + "img/img5.10d6666f.png";